import { Box, TextField } from '@mui/material';

export const VideoSearch = ({ onSearch, value }: { onSearch: (value: string) => void; value?: string }) => {
  return (
    <Box>
      <TextField size="small" label="Search" value={value || ''} onChange={e => onSearch(e.target.value)} sx={{ fontSize: '12px' }} />
    </Box>
  );
};
